import { useEffect, useState } from 'react';

import useDebounce from './use-debounce';
import { useAppSelector } from 'redux/use-hooks';
import { selectOneTokenProjects } from 'redux/slices/tokens';

const useProjectsSearch = () => {
  const projects = useAppSelector(selectOneTokenProjects);
  const [search, setSearch] = useState('');
  const [items, setItems] = useState([]);
  const debouncedSearch = useDebounce(search, 500);

  useEffect(() => {
    if (debouncedSearch !== '') {
      const filtered = projects.filter((item) => {
        return (
          item.name.toLowerCase().indexOf(debouncedSearch.toLowerCase()) !== -1
        );
      });
      setItems(filtered);
    } else {
      setItems(projects);
    }
  }, [debouncedSearch, projects]);

  return { items, search, setSearch };
};

export default useProjectsSearch;
